export default class RouteNotFoundError extends Error {
	readonly status = 404;

	constructor(message = 'Not Found') {
		super(message);
		this.name = 'RouteNotFoundError';
	}
}

export const isRouteNotFoundError = (error: unknown): error is RouteNotFoundError => (
	error instanceof RouteNotFoundError
);
